module.exports = __webpack_public_path__ + "static/media/cyprusFamTour2025_2.995e9f19.jpg";